@if (isBetSlipBadgeVisible()) {
    <ms-my-bets-betslip-badges [betslip]="betslip()" [myBetsListContext]="myBetsListContext()"></ms-my-bets-betslip-badges>
}
@if (isEditButtonVisible) {
    <ms-my-bets-edit-bet-button [betslip]="betslip()" [myBetsListContext]="myBetsListContext()"></ms-my-bets-edit-bet-button>
}
